import { ActionType } from '../../schemas/Home/Home.schema';
import { put, call } from 'redux-saga/effects';
import {
  showPullToRefresh,
  showLoading,
  hidePullToRefresh,
  hideLoading
} from '../../actions/Login/action';
import { DomainConverter } from '../../utils/common';
import {
  membersListSuccess,
  validateUserStatus,
  addUserDetailsSuccess,
  editUserDetailsSuccess,
  removeUserDetailsSuccess
} from '../../actions/manage/action';
import request from '../../utils/request';
import { fetchUserDetailsSuccess } from '../../actions/App/action';
import { addDriverSuccess } from '../../actions/carrierAssign/action';
const APPLICATION_JSON = 'application/json';

/**
 * Get Manage Users List
 * @param action
 */
export function* getManageUsersList(action: ActionType): any {
  const { fetchAllUsersQuery, isPullToRefresh } = action.payload as any;
  try {
    yield put(isPullToRefresh ? showPullToRefresh() : showLoading());
    const fetchAllUsersValue = DomainConverter.domainToData<any>(
      fetchAllUsersQuery
    );
    const fetchAllUsersResponse = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      '',
      fetchAllUsersValue,
      APPLICATION_JSON
    ]);
    const anyList = fetchAllUsersResponse.data
      ? fetchAllUsersResponse.data.getMembers
      : [];
    let usersList = [...anyList];
    // usersList = usersList.filter(
    //   (user: any, index: number) =>
    //     usersList.findIndex(
    //       (user1: any) => user.userPrincipalName === user1.userPrincipalName
    //     ) === index
    // );
    yield put(membersListSuccess({ usersList }));
    yield put(isPullToRefresh ? hidePullToRefresh() : hideLoading());
  } catch (e) {
    yield put(isPullToRefresh ? hidePullToRefresh() : hideLoading());
  }
}

/**
 * Validate user by passing an email
 * @param action
 */
export function* validateUser(action: ActionType): any {
  const { query, callback } = action.payload as any;
  try {
    yield put(showLoading());
    const fetchAllUsersValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      '',
      fetchAllUsersValue,
      APPLICATION_JSON
    ]);
    if (response && response.data) {
      const details =
        (response && response.data && response.data.validateUserByIdentifier) || {};
      const isUserValid = !!(
        response &&
        response.data &&
        response.data.validateUserByIdentifier
      );
      yield put(validateUserStatus({ isUserValid, details }));
    } else {
      callback();
    }
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}

/**
 * Transfer user  from one Carrier to Other Carrier
 * @param action
 */
export function* transferUser(action: ActionType): any {
  const { query, callback } = action.payload as any;
  try {
    yield put(showLoading());
    const fetchAllUsersValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      '',
      fetchAllUsersValue,
      APPLICATION_JSON
    ]);
    if (response && response.data) {
      const status = !!(
        response &&
        response.data &&
        response.data.transferMemberV2 &&
        response.data.transferMemberV2.status
      );
      if(status){
        callback(status);
      }else{
      callback(status, response.data.transferMemberV2.message);
      }
    }
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}

/**
 * Transfer user  from one Carrier to Other Carrier
 * @param action
 */
export function* confirmTransfer(action: ActionType): any {
  const { query, callback } = action.payload as any;
  try {
    yield put(showLoading());
    const queryDetails = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      '',
      queryDetails,
      APPLICATION_JSON
    ]);
    if (response && response.data) {
      const status = !!(
        response &&
        response.data &&
        response.data.confirmTransfer &&
        response.data.confirmTransfer.status
      );
      callback(status,  response.data &&
        response.data.confirmTransfer &&
        response.data.confirmTransfer.message);
    } else {
      callback();
    }
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}

/**
 * Add user details
 * @param action
 */
export function* addUser(action: ActionType): any {
  const { query, callback, isCarrierAssign = false } = action.payload as any;
  try {
    yield put(showLoading());
    const fetchAllUsersValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      '',
      fetchAllUsersValue,
      APPLICATION_JSON
    ]);
    if (
      response &&
      response.data &&
      response.data.addMemberV2 &&
      response.data.addMemberV2.status
    ) {
      const member =
        (response &&
          response.data &&
          response.data.addMemberV2 &&
          response.data.addMemberV2.member) ||
        {};
      yield put(addUserDetailsSuccess({ member }));
      if (isCarrierAssign) {
        yield put(addDriverSuccess({ member }));
      }
      callback(true);
    } else {
      callback();
    }
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}

/**
 * Update user details
 * @param action
 */
export function* updateUser(action: ActionType): any {
  const { query, isProfile = false, callback } = action.payload as any;
  try {
    yield put(showLoading());
    const fetchAllUsersValue = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'EXP_GET_MEMBER',
      null,
      '',
      fetchAllUsersValue,
      APPLICATION_JSON
    ]);
    if (
      updateMemberCheck(response)
    ) {
      const member = getMember(response);
      const roles = getRole(member);
      if (isProfile) {
        yield put(
          fetchUserDetailsSuccess({ member :{
            ...member,
            defaultMobileNumber: member.mobileNumber || '',
            mobileNumber: member.mobileNumber
              ? member.mobileNumber
              : '',
            roles
      }})
        );
      } else {
        yield put(
          editUserDetailsSuccess({
            member: {
              ...member,
              defaultMobileNumber: member.mobileNumber || '',
              mobileNumber: member.mobileNumber
                ? member.mobileNumber
                : '',
              roles
            }
          })
        );
      }
      callback(true, {...member, ...roles});
    } else {
      callback();
    }
    yield put(hideLoading());
  } catch (e) {
    yield put(hideLoading());
  }
}

function getRole(member: any) {
  return member &&
    member.userApplicationDetails &&
    member.userApplicationDetails.reduce(
      (roles: Array<any>, item: any) => {
        const itemRoles = (item.roles && item.roles.map((role: any) => role.roleName)) ||
          [];
        return [...roles, ...itemRoles];
      },
      []
    )||[];
}

function getMember(response: any) {
  return response &&
    response.data &&
    response.data.updateMember &&
    response.data.updateMember.member ||{};
}

function updateMemberCheck(response: any) {
  return response &&
    response.data &&
    response.data.updateMember &&
    response.data.updateMember.status;
}

/**
 * Remove user details
 * @param action
 */
export function* removeUser(action: ActionType): any {
  const { query, userId, callback } = action.payload as any;
  try {
    yield put(showLoading());
    const value = DomainConverter.domainToData<any>(query);
    const response = yield call(request, [
      'FETCH_USER_DETAILS',
      'USER_DETAILS',
      null,
      '',
      value,
      APPLICATION_JSON
    ]);
    if (
      response &&
      response.data &&
      response.data.updateMember &&
      response.data.updateMember.status
    ) {
      yield put(removeUserDetailsSuccess({ userId }));
      callback(true);
    } else {
      callback();
    }
    yield put(hideLoading());
  } catch (e) {
    callback();
    yield put(hideLoading());
  }
}

export function* reSendInvite(action: any) {    
    const { query, callback } = action.payload;
    try {
      yield put(showLoading());
      const reSendInviteresponse = yield call(request, [
        'FETCH_USER_DETAILS',
        'RESEND_INVITE_NOTIFICATION',
        null,
        "",
        query,
        APPLICATION_JSON
      ]);
      if (reSendInviteresponse?.success) {
        callback &&
          callback("success", {
            message: reSendInviteresponse?.message,
            success: reSendInviteresponse?.success
          });
      } else {
        const errorMessage: any =
        reSendInviteresponse &&
        reSendInviteresponse?.errors.length > 0 &&
        reSendInviteresponse?.errors?.map((error: any) => error?.message).join(", ");
        callback &&
          callback("failed", {
            message: errorMessage
          });
      }
    } catch (error) {
      callback &&
          callback("failed", {
            message: error.message
          });
    } finally {
      yield put(hideLoading());
    }
  }